import React from 'react';
import ToastPanel from 'ff/debrief/layouts/ToastPanel';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { useDebriefStatus } from 'ff/debrief/hooks';

const ProcessingStatusToast = () => {
    const { isReanalyzing } = useDebriefStatus();

    return (
        <ToastPanel>
            {isReanalyzing && (
                <Alert icon={<CircularProgress size={16} />} severity="info">
                    Re-analyzing
                </Alert>
            )}
        </ToastPanel>
    );
};

export default ProcessingStatusToast;
